<div class="backDrop" *ngIf="showDialog$ | async">
    <div class="modal-dialog modal-s">
        <div *ngIf="resultModel$ | async as resultModel" class="modal-content ">
            <div>
                <div class="modal-header">
                    <h4 class="modal-title">Warnings</h4>
                </div>

                <div class="modal-body">
                    <div *ngFor="let warning of resultModel.warnings">{{warning}}</div>
                </div>

                <div class="modal-footer">
                    <button *ngIf="(resultModel.warningReport?.trim()).length > 0" type="button" class="btn btn-success" (click)="download()">
						Download warning report
					</button>
                    <button type="button" class="btn btn-primary" (click)="close()">
						Close
					</button>
                </div>
            </div>
        </div>
    </div>
</div>
